module.exports = __webpack_public_path__ + "img/14.1.8cb8fd45.jpg";